<template>
  <div class="ess-element-wrap">
    <div class="ess-line" :class="get_line_class(data.data.p_total)">
    </div>
    <div class="ess-element">
      <div class="ess-element__header">
        <img src="@/assets/images/topo/ic_elink.png" height="24" alt="" srcset="">
        <span class="ess-element__name"  :title="data.uuid">{{ data.eLinkName }}</span>        
      </div>
      <div class="ess-element__body">
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/eLink有功功率')"> {{$str.getKey('数据可视化/功率')}}：<b>{{ formatter(data.data.p_total) }}</b>kW</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/电池荷电量百分比')">SOC：<b>{{ formatter(data.data.soc) }}</b>%</span>
        </div>
      </div>
    </div>
    <div class="ess-line" :class="get_line_class(data.data.p_total)"></div>
  </div>
</template>

<script>
import mixin from './mixin'
import { More } from '@element-plus/icons-vue'
const $str = window.$str
const ELKStatus = {
  1: '停机',
  2: '待机',
  3: '充电',
  4: '放电',
}
export default {
  setup() {
    return {
      $str
    }
  },
  mixins:[mixin],
  props: ['data'],
  components: {
    More
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          data:{}
        }
      }
    }
  },
  methods: {
    handleCommand(command) {
      showTopTip('click on item ' + command, 'success');
    },
    formatter(value) {
      if (value == null) {
        return '--'
      }
      return value
    },
    formatter_s(p) {
      // return ELKStatus[s] || '--'
      if (p == null) {
        return '--'
      }
      if (Math.abs(p) < 1) {
        return $str.getKey('站级监控/停机')
      }
      // charge
      if (p > 0) {
        return $str.getKey('站级监控/放电')
      }
      else if (p < 0) {
        return $str.getKey('站级监控/充电')
      }
      else {
        return $str.getKey('站级监控/停机')
      }
    },
    get_s_class(p) {
      if (p == null) {
        return ''
      }
      // charge
      if (p > 0) {
        return 'discharge'
      } else if (p < 0) {
        return 'charge'
      }
      return ''
    },
    get_line_class(p) {
      if (p == null) {
        return ''
      }
      if (Math.abs(p) < 1) {
        return ''
      }
      if (p > 0) {
        return 'up'
      } else if (p < 0) {
        return 'down'
      } else {
        return ''
      }
    },
  }
}
</script>

